// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile Styles */

/* ===== Accessibility Utilities ===== */

/* Visually hidden but available to screen readers */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* Skip link for keyboard navigation */
.skip-link {
  position: absolute;
  top: -60px;
  left: 0px;
  background: #f8b500;
  color: #1a1a2e;
  padding: 12px 20px;
  text-decoration: none;
  z-index: 10000;
  font-weight: bold;
  border-radius: 0 0 8px 0;
  font-size: 16px;
  transition: top 0.2s ease;
}

.skip-link:focus {
  top: 0;
  outline: 3px solid #ffc832;
  outline-offset: 2px;
}

/* Enhanced focus indicators for mobile */
*:focus {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
}

*:focus:not(:focus-visible) {
  outline: none;
}

*:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);
}

/* ===== Auth layout back link (sibling of .mobile-auth) ===== */
.auth-layout-nav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  padding: 8px 16px;
}

.auth-back-link {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 8px 4px;
  color: #f8b500;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.auth-back-link:hover,
.auth-back-link:active {
  color: #ffc832;
  text-decoration: underline;
}

.auth-back-link:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);
}

/* ===== Mobile Auth Page ===== */
.mobile-auth {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  padding: 56px 20px 24px;
  background: linear-gradient(165deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: #e8e8e8;
  box-sizing: border-box;
}

.mobile-auth-header {
  text-align: center;
  margin-bottom: 32px;
  padding-top: 8px;
}

.mobile-auth-title {
  font-family: 'Space Mono', 'Courier New', monospace;
  font-size: 28px;
  font-weight: 700;
  color: #f8b500;
  margin: 0 0 8px;
  letter-spacing: -0.5px;
}

.mobile-auth-subtitle {
  font-size: 14px;
  color: #8a8a9a;
  margin: 0;
}

/* Welcome landing page */
.mobile-welcome {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  padding: 20px 0;
}

.mobile-welcome-text {
  font-size: 16px;
  line-height: 1.6;
  color: #c0c0d0;
  margin: 0;
  text-align: center;
}

.mobile-welcome-link {
  color: #f8b500;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.mobile-welcome-link:hover,
.mobile-welcome-link:active {
  color: #ffc832;
  text-decoration: underline;
}

.mobile-auth-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 4px;
}

.mobile-auth-tab {
  flex: 1;
  padding: 14px 16px;
  border: none;
  background: transparent;
  color: #8a8a9a;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-auth-tab:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);
}

.mobile-auth-tab.active {
  background: rgba(248, 181, 0, 0.15);
  color: #f8b500;
}

.mobile-auth-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.mobile-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mobile-form-group label {
  font-size: 13px;
  font-weight: 500;
  color: #b0b0c0;
}

.mobile-form-group input {
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: #e8e8e8;
  font-size: 16px; /* Prevents iOS zoom on focus */
  transition: all 0.2s ease;
}

.mobile-form-group input:focus {
  outline: none;
  border-color: #f8b500;
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 0 0 4px rgba(248, 181, 0, 0.15);
}

.mobile-form-group input:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: -1px;
}

.mobile-form-group input::placeholder {
  color: #5a5a6a;
}

.mobile-error {
  padding: 12px 16px;
  background: rgba(220, 53, 69, 0.15);
  border: 1px solid rgba(220, 53, 69, 0.3);
  border-radius: 10px;
  color: #ff6b7a;
  font-size: 14px;
}

.mobile-playback-error {
  display: grid;
  gap: 4px;
  margin: 10px 16px;
  padding: 10px 12px;
  color: #ffb0ba;
  background: rgba(220, 53, 69, 0.12);
  border: 1px solid rgba(220, 53, 69, 0.34);
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.35;
}

.mobile-playback-error strong {
  font-size: 10px;
  letter-spacing: 0.7px;
  text-transform: uppercase;
}

.mobile-submit-btn {
  padding: 16px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8b500 0%, #e6a600 100%);
  color: #1a1a2e;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 8px;
  transition: all 0.2s ease;
  min-height: 52px;
}

.mobile-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mobile-submit-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.mobile-submit-btn:focus-visible {
  outline: 3px solid #ffc832;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.3);
}

.mobile-submit-btn--secondary {
  background: transparent;
  color: #f8b500;
  border: 1px solid rgba(248, 181, 0, 0.5);
}

.mobile-submit-btn--secondary:active:not(:disabled) {
  background: rgba(248, 181, 0, 0.08);
}

.mobile-welcome-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.mobile-form-options {
  display: flex;
  justify-content: flex-end;
  margin-top: -4px;
}

.mobile-forgot-password {
  color: #f8b500;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 2px;
}

.mobile-forgot-password:hover,
.mobile-forgot-password:active,
.mobile-forgot-password:focus-visible {
  color: #ffc832;
  text-decoration: underline;
}

.mobile-forgot-password:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  border-radius: 4px;
}

.mobile-required {
  color: #ff6b7a;
  font-weight: 700;
  margin-left: 2px;
}

.mobile-field-error {
  font-size: 13px;
  color: #ff6b7a;
  margin-top: 2px;
}

.mobile-password-strength {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
}

.mobile-strength-bar {
  height: 4px;
  width: 100%;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
}

.mobile-strength-bar-fill {
  height: 100%;
  transition: width 0.2s ease, background-color 0.2s ease;
  background: #5a5a6a;
}

.mobile-strength-bar-fill.weak {
  background: #ff6b7a;
}

.mobile-strength-bar-fill.medium {
  background: #f8b500;
}

.mobile-strength-bar-fill.strong {
  background: #4ade80;
}

.mobile-strength-text {
  font-size: 12px;
  color: #8a8a9a;
}

.mobile-password-requirements {
  padding: 12px 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
}

.mobile-requirements-title {
  font-size: 13px;
  font-weight: 600;
  color: #b0b0c0;
  margin: 0 0 8px;
}

.mobile-requirements-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.mobile-requirement {
  font-size: 13px;
  color: #8a8a9a;
  padding-left: 20px;
  position: relative;
  transition: color 0.2s ease;
}

.mobile-requirement::before {
  content: '○';
  position: absolute;
  left: 0;
  top: 0;
  color: #5a5a6a;
  font-size: 14px;
  line-height: 1;
}

.mobile-requirement.met {
  color: #4ade80;
}

.mobile-requirement.met::before {
  content: '✓';
  color: #4ade80;
  font-weight: 700;
}

.mobile-consent-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
}

.mobile-consent-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
}

.mobile-consent-checkbox input[type='checkbox'] {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  margin: 2px 0 0;
  accent-color: #f8b500;
  cursor: pointer;
}

.mobile-consent-text {
  font-size: 13px;
  line-height: 1.5;
  color: #c0c0d0;
}

.mobile-consent-footer {
  font-size: 12px;
  line-height: 1.5;
  color: #8a8a9a;
  margin: 0;
}

.mobile-consent-privacy {
  font-size: 12px;
  line-height: 1.5;
  color: #8a8a9a;
  margin: 0;
}

.mobile-auth-prompt {
  text-align: center;
  font-size: 14px;
  color: #b0b0c0;
  margin-top: 20px;
}

.mobile-auth-link {
  background: none;
  border: none;
  padding: 0;
  color: #f8b500;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: underline;
}

.mobile-auth-link:hover,
.mobile-auth-link:active {
  color: #ffc832;
}

.mobile-auth-link:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  border-radius: 4px;
}

.mobile-divider {
  display: flex;
  align-items: center;
  margin: 24px 0;
  color: #5a5a6a;
  font-size: 13px;
}

.mobile-divider::before,
.mobile-divider::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-divider span {
  padding: 0 16px;
}

.mobile-sso-buttons {
  display: flex;
  gap: 12px;
}

.mobile-sso-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: #e8e8e8;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  min-height: 48px;
  transition: all 0.2s ease;
}

.mobile-sso-btn:active {
  transform: scale(0.98);
  background: rgba(255, 255, 255, 0.1);
}

.mobile-sso-btn:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);
}

.mobile-sso-icon {
  width: 20px;
  height: 20px;
}

/* ===== Mobile Game Page ===== */
.mobile-game {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(165deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
  color: #e8e8e8;
  box-sizing: border-box;
}

.mobile-game-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: #1a1a2e;
}

.mobile-app-header-top {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.mobile-game-title {
  font-family: 'Space Mono', 'Courier New', monospace;
  font-size: 18px;
  font-weight: 700;
  color: #f8b500;
  margin: 0;
}

.mobile-game-user {
  display: flex;
  align-items: center;
  gap: 12px;
}

.mobile-user-name {
  font-size: 13px;
  color: #8a8a9a;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-logout-btn {
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  background: transparent;
  color: #b0b0c0;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-logout-btn:hover {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.05);
}

.mobile-logout-btn:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);
}

.mobile-game-auth {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-app-header-loading {
  width: 80px;
  min-height: 36px;
}

.mobile-header-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  min-height: 36px;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
}

.mobile-header-btn--secondary {
  background: transparent;
  color: #e8e8e8;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.mobile-header-btn--secondary:hover,
.mobile-header-btn--secondary:active {
  border-color: rgba(255, 255, 255, 0.4);
  background: rgba(255, 255, 255, 0.05);
}

.mobile-header-btn--primary {
  background: linear-gradient(135deg, #f8b500 0%, #e6a600 100%);
  color: #1a1a2e;
  border: 1px solid transparent;
}

.mobile-header-btn--primary:active {
  transform: scale(0.97);
}

.mobile-header-btn:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);
}

.mobile-app-nav {
  display: flex;
  width: 100%;
  gap: 8px;
  overflow-x: auto;
  scrollbar-width: none;
}

.mobile-app-nav::-webkit-scrollbar {
  display: none;
}

.mobile-app-nav__link {
  display: inline-flex;
  min-width: max-content;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 22px;
  color: #d9d9e3;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
}

.mobile-app-nav__link--active {
  border-color: #f8b500;
  background: linear-gradient(135deg, #f8b500 0%, #e6a600 100%);
  color: #1a1a2e;
}

.mobile-app-nav__link:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
}

.mobile-game-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 20px 20px 0 20px;
}

/* Start button tooltip wrapper */
.mobile-start-btn-wrapper {
  position: relative;
  display: flex;
  flex: 1;
}

.mobile-start-btn-wrapper .mobile-play-btn {
  width: 100%;
}

.mobile-play-btn,
.mobile-stop-btn {
  flex: 1;
  padding: 18px;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  min-height: 60px;
  transition: all 0.2s ease;
}

.mobile-play-btn {
  background: linear-gradient(135deg, #00c853 0%, #00a844 100%);
  color: white;
}

.mobile-play-btn:disabled {
  background: #2a4a3a;
  color: #5a7a6a;
}

.mobile-stop-btn {
  background: linear-gradient(135deg, #ff5252 0%, #e04545 100%);
  color: white;
}

.mobile-stop-btn:disabled {
  background: #4a2a2a;
  color: #7a5a5a;
}

.mobile-play-btn:active:not(:disabled),
.mobile-stop-btn:active:not(:disabled) {
  transform: scale(0.98);
}

.mobile-play-btn:focus-visible,
.mobile-stop-btn:focus-visible {
  outline: 3px solid #ffc832;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.3);
}

.mobile-feedback {
  text-align: center;
  padding: 12px;
  font-size: 18px;
  font-weight: 700;
  height: 24px;
  opacity: 1;
  transition: opacity 0.15s ease;
}

.mobile-feedback.hidden {
  opacity: 0;
}

.mobile-feedback.correct {
  color: #00c853;
  animation: feedbackPulse 0.3s ease;
}

.mobile-feedback.incorrect {
  color: #ff5252;
  animation: feedbackPulse 0.3s ease;
}

.mobile-feedback-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.mobile-band-preset-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 8px 16px 0;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
}

.mobile-band-preset-banner p {
  margin: 0;
  font-size: 13px;
  color: #e8e8e8;
}

.mobile-band-preset-banner .btn {
  flex-shrink: 0;
  padding: 8px 12px;
  min-width: 0;
}

@keyframes feedbackPulse {
  0% { transform: scale(0.9); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.mobile-eq-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 12px 16px;
  margin-top: 12px;
  overflow-y: auto;
  align-content: start;
}

.mobile-eq-band {
  padding: 16px 8px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  color: #e8e8e8;
  font-family: 'Space Mono', 'Courier New', monospace;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  min-height: 52px;
  transition: all 0.15s ease;
}

.mobile-eq-band:active:not(:disabled) {
  transform: scale(0.95);
  background: rgba(248, 181, 0, 0.2);
}

.mobile-eq-band.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.mobile-eq-band:focus-visible {
  outline: 3px solid #f8b500;
  outline-offset: 2px;
  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.25);
  z-index: 1;
}

.mobile-eq-band.correct {
  background: rgba(0, 200, 83, 0.3);
  border-color: #00c853;
}

.mobile-eq-band.incorrect {
  background: rgba(255, 82, 82, 0.3);
  border-color: #ff5252;
  animation: shake 0.3s ease;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-4px); }
  75% { transform: translateX(4px); }
}

/* User-disabled band (toggled off via double-tap, but not feature-locked) */
.mobile-eq-band.band-disabled {
  opacity: 0.4;
  border-color: rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.02);
}

.mobile-eq-band.band-disabled:active:not(:disabled) {
  transform: scale(0.95);
  background: rgba(255, 255, 255, 0.05);
}

/* Hint: nearest target frequency band (lights up in free play mode) */
.mobile-eq-band.nearest-target {
  border-color: #f8b500;
  background: rgba(248, 181, 0, 0.2);
  box-shadow: 0 0 12px rgba(248, 181, 0, 0.3);
  animation: hintPulse 1.5s ease-in-out infinite;
}

@keyframes hintPulse {
  0%, 100% { box-shadow: 0 0 12px rgba(248, 181, 0, 0.3); }
  50% { box-shadow: 0 0 20px rgba(248, 181, 0, 0.5); }
}

/* Active preview (tap-and-hold momentary playback) */
.mobile-eq-band.active-preview {
  border-color: #7b68ee;
  background: rgba(123, 104, 238, 0.25);
  box-shadow: 0 0 12px rgba(123, 104, 238, 0.4);
  transform: scale(0.95);
}

.mobile-instructions {
  text-align: center;
  padding: 20px;
  color: #8a8a9a;
  font-size: 14px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.mobile-loading,
.mobile-game .mobile-error {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8a8a9a;
  font-size: 16px;
  padding: 40px;
  text-align: center;
}

/* ===== Mobile Mode Toggle ===== */
.mobile-mode-toggle-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.mobile-mode-toggle-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  position: relative;
}

.mobile-mode-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #5a5a6a;
  transition: color 0.3s ease;
}

.mobile-mode-label.active {
  color: #f8b500;
}

.mobile-mode-toggle-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.mobile-mode-toggle-slider {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  transition: all 0.3s ease;
}

.mobile-mode-toggle-slider::before {
  content: '';
  position: absolute;
  top: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  background: #5a5a6a;
  border-radius: 50%;
  transition: transform 0.3s ease, background 0.3s ease;
}

.mobile-mode-toggle-input:checked + .mobile-mode-toggle-slider {
  background: rgba(74, 156, 109, 0.3);
  border-color: rgba(74, 156, 109, 0.5);
}

.mobile-mode-toggle-input:checked + .mobile-mode-toggle-slider::before {
  transform: translateX(20px);
  background: #4a9c6d;
}

.mobile-mode-toggle-label.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.mobile-mode-toggle-label.disabled .mobile-mode-toggle-slider {
  cursor: not-allowed;
}

.mobile-mode-toggle-label.disabled .mobile-mode-label {
  cursor: not-allowed;
}

.mobile-mode-toggle-input:disabled {
  cursor: not-allowed;
}

.mobile-mode-caption,
.mobile-locked-caption {
  margin: 0;
  color: #8a8a9a;
  font-size: 12px;
  line-height: 1.4;
  text-align: center;
}

.mobile-locked-caption {
  padding: 8px 16px 0;
}

`, "",{"version":3,"sources":["webpack://./src/client/styles/mobile.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB,wCAAwC;;AAExC,oDAAoD;AACpD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,MAAM;EACN,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;;EAKE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0EAA0E;EAC1E,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe,EAAE,+BAA+B;EAChD,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,iDAAiD;AACnD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,0EAA0E;EAC1E,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;EAEE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,KAAK,qBAAqB,EAAE;EAC5B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,4EAA4E;AAC5E;EACE,YAAY;EACZ,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA,sEAAsE;AACtE;EACE,qBAAqB;EACrB,kCAAkC;EAClC,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,WAAW,2CAA2C,EAAE;EACxD,MAAM,2CAA2C,EAAE;AACrD;;AAEA,qDAAqD;AACrD;EACE,qBAAqB;EACrB,qCAAqC;EACrC,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,8CAA8C;AAChD;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Mobile Styles */\n\n/* ===== Accessibility Utilities ===== */\n\n/* Visually hidden but available to screen readers */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Skip link for keyboard navigation */\n.skip-link {\n  position: absolute;\n  top: -60px;\n  left: 0px;\n  background: #f8b500;\n  color: #1a1a2e;\n  padding: 12px 20px;\n  text-decoration: none;\n  z-index: 10000;\n  font-weight: bold;\n  border-radius: 0 0 8px 0;\n  font-size: 16px;\n  transition: top 0.2s ease;\n}\n\n.skip-link:focus {\n  top: 0;\n  outline: 3px solid #ffc832;\n  outline-offset: 2px;\n}\n\n/* Enhanced focus indicators for mobile */\n*:focus {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n}\n\n*:focus:not(:focus-visible) {\n  outline: none;\n}\n\n*:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n}\n\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);\n}\n\n/* ===== Auth layout back link (sibling of .mobile-auth) ===== */\n.auth-layout-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 20;\n  padding: 8px 16px;\n}\n\n.auth-back-link {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  padding: 8px 4px;\n  color: #f8b500;\n  font-size: 15px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.auth-back-link:hover,\n.auth-back-link:active {\n  color: #ffc832;\n  text-decoration: underline;\n}\n\n.auth-back-link:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);\n}\n\n/* ===== Mobile Auth Page ===== */\n.mobile-auth {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  padding: 56px 20px 24px;\n  background: linear-gradient(165deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n  color: #e8e8e8;\n  box-sizing: border-box;\n}\n\n.mobile-auth-header {\n  text-align: center;\n  margin-bottom: 32px;\n  padding-top: 8px;\n}\n\n.mobile-auth-title {\n  font-family: 'Space Mono', 'Courier New', monospace;\n  font-size: 28px;\n  font-weight: 700;\n  color: #f8b500;\n  margin: 0 0 8px;\n  letter-spacing: -0.5px;\n}\n\n.mobile-auth-subtitle {\n  font-size: 14px;\n  color: #8a8a9a;\n  margin: 0;\n}\n\n/* Welcome landing page */\n.mobile-welcome {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 24px;\n  padding: 20px 0;\n}\n\n.mobile-welcome-text {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #c0c0d0;\n  margin: 0;\n  text-align: center;\n}\n\n.mobile-welcome-link {\n  color: #f8b500;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.2s ease;\n}\n\n.mobile-welcome-link:hover,\n.mobile-welcome-link:active {\n  color: #ffc832;\n  text-decoration: underline;\n}\n\n.mobile-auth-tabs {\n  display: flex;\n  gap: 0;\n  margin-bottom: 24px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 4px;\n}\n\n.mobile-auth-tab {\n  flex: 1;\n  padding: 14px 16px;\n  border: none;\n  background: transparent;\n  color: #8a8a9a;\n  font-size: 15px;\n  font-weight: 600;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mobile-auth-tab:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);\n}\n\n.mobile-auth-tab.active {\n  background: rgba(248, 181, 0, 0.15);\n  color: #f8b500;\n}\n\n.mobile-auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.mobile-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.mobile-form-group label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #b0b0c0;\n}\n\n.mobile-form-group input {\n  padding: 14px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #e8e8e8;\n  font-size: 16px; /* Prevents iOS zoom on focus */\n  transition: all 0.2s ease;\n}\n\n.mobile-form-group input:focus {\n  outline: none;\n  border-color: #f8b500;\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: 0 0 0 4px rgba(248, 181, 0, 0.15);\n}\n\n.mobile-form-group input:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: -1px;\n}\n\n.mobile-form-group input::placeholder {\n  color: #5a5a6a;\n}\n\n.mobile-error {\n  padding: 12px 16px;\n  background: rgba(220, 53, 69, 0.15);\n  border: 1px solid rgba(220, 53, 69, 0.3);\n  border-radius: 10px;\n  color: #ff6b7a;\n  font-size: 14px;\n}\n\n.mobile-playback-error {\n  display: grid;\n  gap: 4px;\n  margin: 10px 16px;\n  padding: 10px 12px;\n  color: #ffb0ba;\n  background: rgba(220, 53, 69, 0.12);\n  border: 1px solid rgba(220, 53, 69, 0.34);\n  border-radius: 10px;\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n.mobile-playback-error strong {\n  font-size: 10px;\n  letter-spacing: 0.7px;\n  text-transform: uppercase;\n}\n\n.mobile-submit-btn {\n  padding: 16px;\n  border: none;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #f8b500 0%, #e6a600 100%);\n  color: #1a1a2e;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: all 0.2s ease;\n  min-height: 52px;\n}\n\n.mobile-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.mobile-submit-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.mobile-submit-btn:focus-visible {\n  outline: 3px solid #ffc832;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.3);\n}\n\n.mobile-submit-btn--secondary {\n  background: transparent;\n  color: #f8b500;\n  border: 1px solid rgba(248, 181, 0, 0.5);\n}\n\n.mobile-submit-btn--secondary:active:not(:disabled) {\n  background: rgba(248, 181, 0, 0.08);\n}\n\n.mobile-welcome-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 8px;\n}\n\n.mobile-form-options {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: -4px;\n}\n\n.mobile-forgot-password {\n  color: #f8b500;\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 4px 2px;\n}\n\n.mobile-forgot-password:hover,\n.mobile-forgot-password:active,\n.mobile-forgot-password:focus-visible {\n  color: #ffc832;\n  text-decoration: underline;\n}\n\n.mobile-forgot-password:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.mobile-required {\n  color: #ff6b7a;\n  font-weight: 700;\n  margin-left: 2px;\n}\n\n.mobile-field-error {\n  font-size: 13px;\n  color: #ff6b7a;\n  margin-top: 2px;\n}\n\n.mobile-password-strength {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 4px;\n}\n\n.mobile-strength-bar {\n  height: 4px;\n  width: 100%;\n  background: rgba(255, 255, 255, 0.08);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.mobile-strength-bar-fill {\n  height: 100%;\n  transition: width 0.2s ease, background-color 0.2s ease;\n  background: #5a5a6a;\n}\n\n.mobile-strength-bar-fill.weak {\n  background: #ff6b7a;\n}\n\n.mobile-strength-bar-fill.medium {\n  background: #f8b500;\n}\n\n.mobile-strength-bar-fill.strong {\n  background: #4ade80;\n}\n\n.mobile-strength-text {\n  font-size: 12px;\n  color: #8a8a9a;\n}\n\n.mobile-password-requirements {\n  padding: 12px 14px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n}\n\n.mobile-requirements-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #b0b0c0;\n  margin: 0 0 8px;\n}\n\n.mobile-requirements-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.mobile-requirement {\n  font-size: 13px;\n  color: #8a8a9a;\n  padding-left: 20px;\n  position: relative;\n  transition: color 0.2s ease;\n}\n\n.mobile-requirement::before {\n  content: '○';\n  position: absolute;\n  left: 0;\n  top: 0;\n  color: #5a5a6a;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.mobile-requirement.met {\n  color: #4ade80;\n}\n\n.mobile-requirement.met::before {\n  content: '✓';\n  color: #4ade80;\n  font-weight: 700;\n}\n\n.mobile-consent-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 14px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n}\n\n.mobile-consent-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  cursor: pointer;\n}\n\n.mobile-consent-checkbox input[type='checkbox'] {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  margin: 2px 0 0;\n  accent-color: #f8b500;\n  cursor: pointer;\n}\n\n.mobile-consent-text {\n  font-size: 13px;\n  line-height: 1.5;\n  color: #c0c0d0;\n}\n\n.mobile-consent-footer {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #8a8a9a;\n  margin: 0;\n}\n\n.mobile-consent-privacy {\n  font-size: 12px;\n  line-height: 1.5;\n  color: #8a8a9a;\n  margin: 0;\n}\n\n.mobile-auth-prompt {\n  text-align: center;\n  font-size: 14px;\n  color: #b0b0c0;\n  margin-top: 20px;\n}\n\n.mobile-auth-link {\n  background: none;\n  border: none;\n  padding: 0;\n  color: #f8b500;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.mobile-auth-link:hover,\n.mobile-auth-link:active {\n  color: #ffc832;\n}\n\n.mobile-auth-link:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.mobile-divider {\n  display: flex;\n  align-items: center;\n  margin: 24px 0;\n  color: #5a5a6a;\n  font-size: 13px;\n}\n\n.mobile-divider::before,\n.mobile-divider::after {\n  content: '';\n  flex: 1;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mobile-divider span {\n  padding: 0 16px;\n}\n\n.mobile-sso-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.mobile-sso-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #e8e8e8;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  min-height: 48px;\n  transition: all 0.2s ease;\n}\n\n.mobile-sso-btn:active {\n  transform: scale(0.98);\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.mobile-sso-btn:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);\n}\n\n.mobile-sso-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* ===== Mobile Game Page ===== */\n.mobile-game {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(165deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n  color: #e8e8e8;\n  box-sizing: border-box;\n}\n\n.mobile-game-header {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 12px 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  background: #1a1a2e;\n}\n\n.mobile-app-header-top {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.mobile-game-title {\n  font-family: 'Space Mono', 'Courier New', monospace;\n  font-size: 18px;\n  font-weight: 700;\n  color: #f8b500;\n  margin: 0;\n}\n\n.mobile-game-user {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.mobile-user-name {\n  font-size: 13px;\n  color: #8a8a9a;\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-logout-btn {\n  padding: 8px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  background: transparent;\n  color: #b0b0c0;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mobile-logout-btn:hover {\n  border-color: rgba(255, 255, 255, 0.4);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.mobile-logout-btn:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);\n}\n\n.mobile-game-auth {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mobile-app-header-loading {\n  width: 80px;\n  min-height: 36px;\n}\n\n.mobile-header-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  min-height: 36px;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.mobile-header-btn--secondary {\n  background: transparent;\n  color: #e8e8e8;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.mobile-header-btn--secondary:hover,\n.mobile-header-btn--secondary:active {\n  border-color: rgba(255, 255, 255, 0.4);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.mobile-header-btn--primary {\n  background: linear-gradient(135deg, #f8b500 0%, #e6a600 100%);\n  color: #1a1a2e;\n  border: 1px solid transparent;\n}\n\n.mobile-header-btn--primary:active {\n  transform: scale(0.97);\n}\n\n.mobile-header-btn:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.2);\n}\n\n.mobile-app-nav {\n  display: flex;\n  width: 100%;\n  gap: 8px;\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.mobile-app-nav::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-app-nav__link {\n  display: inline-flex;\n  min-width: max-content;\n  min-height: 44px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 14px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 22px;\n  color: #d9d9e3;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.mobile-app-nav__link--active {\n  border-color: #f8b500;\n  background: linear-gradient(135deg, #f8b500 0%, #e6a600 100%);\n  color: #1a1a2e;\n}\n\n.mobile-app-nav__link:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n}\n\n.mobile-game-controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 20px 20px 0 20px;\n}\n\n/* Start button tooltip wrapper */\n.mobile-start-btn-wrapper {\n  position: relative;\n  display: flex;\n  flex: 1;\n}\n\n.mobile-start-btn-wrapper .mobile-play-btn {\n  width: 100%;\n}\n\n.mobile-play-btn,\n.mobile-stop-btn {\n  flex: 1;\n  padding: 18px;\n  border: none;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  cursor: pointer;\n  min-height: 60px;\n  transition: all 0.2s ease;\n}\n\n.mobile-play-btn {\n  background: linear-gradient(135deg, #00c853 0%, #00a844 100%);\n  color: white;\n}\n\n.mobile-play-btn:disabled {\n  background: #2a4a3a;\n  color: #5a7a6a;\n}\n\n.mobile-stop-btn {\n  background: linear-gradient(135deg, #ff5252 0%, #e04545 100%);\n  color: white;\n}\n\n.mobile-stop-btn:disabled {\n  background: #4a2a2a;\n  color: #7a5a5a;\n}\n\n.mobile-play-btn:active:not(:disabled),\n.mobile-stop-btn:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n.mobile-play-btn:focus-visible,\n.mobile-stop-btn:focus-visible {\n  outline: 3px solid #ffc832;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.3);\n}\n\n.mobile-feedback {\n  text-align: center;\n  padding: 12px;\n  font-size: 18px;\n  font-weight: 700;\n  height: 24px;\n  opacity: 1;\n  transition: opacity 0.15s ease;\n}\n\n.mobile-feedback.hidden {\n  opacity: 0;\n}\n\n.mobile-feedback.correct {\n  color: #00c853;\n  animation: feedbackPulse 0.3s ease;\n}\n\n.mobile-feedback.incorrect {\n  color: #ff5252;\n  animation: feedbackPulse 0.3s ease;\n}\n\n.mobile-feedback-row {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.mobile-band-preset-banner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin: 8px 16px 0;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n}\n\n.mobile-band-preset-banner p {\n  margin: 0;\n  font-size: 13px;\n  color: #e8e8e8;\n}\n\n.mobile-band-preset-banner .btn {\n  flex-shrink: 0;\n  padding: 8px 12px;\n  min-width: 0;\n}\n\n@keyframes feedbackPulse {\n  0% { transform: scale(0.9); }\n  50% { transform: scale(1.05); }\n  100% { transform: scale(1); }\n}\n\n.mobile-eq-grid {\n  flex: 1;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  padding: 12px 16px;\n  margin-top: 12px;\n  overflow-y: auto;\n  align-content: start;\n}\n\n.mobile-eq-band {\n  padding: 16px 8px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #e8e8e8;\n  font-family: 'Space Mono', 'Courier New', monospace;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  min-height: 52px;\n  transition: all 0.15s ease;\n}\n\n.mobile-eq-band:active:not(:disabled) {\n  transform: scale(0.95);\n  background: rgba(248, 181, 0, 0.2);\n}\n\n.mobile-eq-band.disabled {\n  opacity: 0.3;\n  cursor: not-allowed;\n}\n\n.mobile-eq-band:focus-visible {\n  outline: 3px solid #f8b500;\n  outline-offset: 2px;\n  box-shadow: 0 0 0 6px rgba(248, 181, 0, 0.25);\n  z-index: 1;\n}\n\n.mobile-eq-band.correct {\n  background: rgba(0, 200, 83, 0.3);\n  border-color: #00c853;\n}\n\n.mobile-eq-band.incorrect {\n  background: rgba(255, 82, 82, 0.3);\n  border-color: #ff5252;\n  animation: shake 0.3s ease;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-4px); }\n  75% { transform: translateX(4px); }\n}\n\n/* User-disabled band (toggled off via double-tap, but not feature-locked) */\n.mobile-eq-band.band-disabled {\n  opacity: 0.4;\n  border-color: rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.mobile-eq-band.band-disabled:active:not(:disabled) {\n  transform: scale(0.95);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n/* Hint: nearest target frequency band (lights up in free play mode) */\n.mobile-eq-band.nearest-target {\n  border-color: #f8b500;\n  background: rgba(248, 181, 0, 0.2);\n  box-shadow: 0 0 12px rgba(248, 181, 0, 0.3);\n  animation: hintPulse 1.5s ease-in-out infinite;\n}\n\n@keyframes hintPulse {\n  0%, 100% { box-shadow: 0 0 12px rgba(248, 181, 0, 0.3); }\n  50% { box-shadow: 0 0 20px rgba(248, 181, 0, 0.5); }\n}\n\n/* Active preview (tap-and-hold momentary playback) */\n.mobile-eq-band.active-preview {\n  border-color: #7b68ee;\n  background: rgba(123, 104, 238, 0.25);\n  box-shadow: 0 0 12px rgba(123, 104, 238, 0.4);\n  transform: scale(0.95);\n}\n\n.mobile-instructions {\n  text-align: center;\n  padding: 20px;\n  color: #8a8a9a;\n  font-size: 14px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.mobile-loading,\n.mobile-game .mobile-error {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #8a8a9a;\n  font-size: 16px;\n  padding: 40px;\n  text-align: center;\n}\n\n/* ===== Mobile Mode Toggle ===== */\n.mobile-mode-toggle-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.mobile-mode-toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n}\n\n.mobile-mode-label {\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #5a5a6a;\n  transition: color 0.3s ease;\n}\n\n.mobile-mode-label.active {\n  color: #f8b500;\n}\n\n.mobile-mode-toggle-input {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.mobile-mode-toggle-slider {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  transition: all 0.3s ease;\n}\n\n.mobile-mode-toggle-slider::before {\n  content: '';\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  background: #5a5a6a;\n  border-radius: 50%;\n  transition: transform 0.3s ease, background 0.3s ease;\n}\n\n.mobile-mode-toggle-input:checked + .mobile-mode-toggle-slider {\n  background: rgba(74, 156, 109, 0.3);\n  border-color: rgba(74, 156, 109, 0.5);\n}\n\n.mobile-mode-toggle-input:checked + .mobile-mode-toggle-slider::before {\n  transform: translateX(20px);\n  background: #4a9c6d;\n}\n\n.mobile-mode-toggle-label.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.mobile-mode-toggle-label.disabled .mobile-mode-toggle-slider {\n  cursor: not-allowed;\n}\n\n.mobile-mode-toggle-label.disabled .mobile-mode-label {\n  cursor: not-allowed;\n}\n\n.mobile-mode-toggle-input:disabled {\n  cursor: not-allowed;\n}\n\n.mobile-mode-caption,\n.mobile-locked-caption {\n  margin: 0;\n  color: #8a8a9a;\n  font-size: 12px;\n  line-height: 1.4;\n  text-align: center;\n}\n\n.mobile-locked-caption {\n  padding: 8px 16px 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
